<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>订单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="queryParams.code" placeholder="请输入代码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="queryParams.name" placeholder="请输入名称" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item" v-if="postList.supplier_rid">
                <vSearchSelect
                    model_key="supplier_rid"
                    model_name="请输入供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="supplier_option"
                    :default_option="queryParams['supplier_option']"
                    @onDropChange="onDropChange"
                    ref="supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.demander_rid">
                <vSearchSelect
                    model_key="demander_rid"
                    model_name="请输入需方搜索"
                    request_uri="searchAccounts"
                    default_option_key="demander_option"
                    :default_option="queryParams['demander_option']"
                    @onDropChange="onDropChange"
                    ref="demander_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.partner_rid">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="order"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['code', 'name', 'supplier_name', 'demander_name', 'partner_name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <!--
                接口废弃
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="同步发货信息" placement="top-start">
                            <i class="el-icon-refresh" @click="syncShipmentInfo(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                -->
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common';
import draggableList from '@/components/common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect
    },
    name: 'orderComponent',
    data() {
        return {
            draggable: {
                data_name: 'order'
            },
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        syncShipmentInfo(row) {
            let message = '您确定要同步吗 [' + row.name + '] 吗？';

            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['syncShipmentInfo']({
                        rid: row.rid
                    })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '同步成功！',
                                    type: 'success'
                                });
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});

            return true;
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['code', 'name'])) {
                this.$router.push({
                    path: '/orderDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'supplier_name' && row.supplier_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.supplier_rid
                    }
                });
            } else if (prop == 'demander_name' && row.demander_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.demander_rid
                    }
                });
            } else if (prop == 'partner_name' && row.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                code: '',
                name: '',
                supplier_rid: '',
                demander_rid: '',
                partner_rid: '',
                supplier_option: {},
                demander_option: {}
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('order_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('order_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                        this.queryParams.supplier_option = queryParams.supplier_option || {};
                        this.queryParams.demander_option = queryParams.demander_option || {};
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('order', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).order;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'orderLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //删除
        del(row) {
            // onDelete(row.id, this, 'orderDelete', row.name);
        },
        //编辑
        update(rid) {
            // this.$router.push({
            //     path: 'orderEdit',
            //     query: {
            //         type: 'update',
            //         id: rid
            //     }
            // });
        },
        //新增
        insert() {
            // this.$router.push({
            //     path: 'orderEdit',
            //     query: {
            //         type: 'insert'
            //     }
            // });
        },
        //复制
        copy(rid) {
            // this.$router.push({
            //     path: 'orderEdit',
            //     query: {
            //         type: 'copy',
            //         id: rid
            //     }
            // });
        },
        reset() {
            this.initQueryParams();
            this.$refs.supplier_rid_ref && this.$refs.supplier_rid_ref.reset();
            this.$refs.demander_rid_ref && this.$refs.demander_rid_ref.reset();
            this.$refs.partner_rid_ref && this.$refs.partner_rid_ref.reset();

            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>